<template>
  <div ref="container">
    <a-modal
      title="绑定商品（新增菜品）"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确定绑定"
      style="top: 80px;">
      <a-spin :spinning="loading">
        <!-- 搜索 -->
        <div style="margin-bottom: 12px;">
          <a-input-search
            placeholder="请输入商品名搜索"
            v-model="querySearch"
            style="width: 300px"
            allow-clear
            @search="() => load(1)" />
        </div>
        <!-- 商品选择列表 -->
        <a-table
          size="small"
          bordered
          rowKey="materialId"
          :columns="columns"
          :dataSource="rows"
          :pagination="pager"
          @change="onTableChange">
          <template slot="radioSlot" slot-scope="text, record">
            <a-radio :checked="selectedId === record.materialId" @click="() => selectMaterial(record)" />
          </template>
          <template slot="imgSlot" slot-scope="text, record">
            <img v-if="getImgUrl(record.imgName)" :src="getImgUrl(record.imgName)" class="bind-thumb" />
            <span v-else>-</span>
          </template>
        </a-table>
        <!-- 绑定信息 -->
        <a-form style="margin-top: 16px;">
          <a-form-item label="已选商品">
            <span v-if="selectedName">{{ selectedName }}</span>
            <span v-else style="color: #999;">请在上方列表选择商品</span>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述">
            <a-textarea :rows="2" placeholder="请输入菜品描述（可选）" v-model="description" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
            <a-input-number :min="0" :precision="0" placeholder="数字越小越靠前" v-model="sort" style="width: 100%;" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { goodsAdd, goodsMaterialsOptions } from '@/api/plugin/dining'
import { getFileAccessHttpUrl } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin'

/**
 * 绑定商品弹窗（Task 9）：goodsMaterialsOptions 搜索+分页单选，确定调 goodsAdd
 */
export default {
  name: 'GoodsBindModal',
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      loading: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      querySearch: '',
      rows: [],
      pager: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`
      },
      selectedId: null,
      selectedName: '',
      description: '',
      sort: 0,
      columns: [
        { title: '选择', dataIndex: 'radio', width: 60, align: 'center', scopedSlots: { customRender: 'radioSlot' } },
        { title: '商品图', dataIndex: 'imgName', width: 80, align: 'center', scopedSlots: { customRender: 'imgSlot' } },
        { title: '商品名', dataIndex: 'materialName', align: 'left' },
        { title: '最低价', dataIndex: 'minPrice', width: 100, align: 'right',
          customRender: function(text) { return text === null || text === undefined || text === '' ? '-' : text } }
      ]
    }
  },
  methods: {
    open() {
      this.visible = true
      this.querySearch = ''
      this.selectedId = null
      this.selectedName = ''
      this.description = ''
      this.sort = 0
      this.load(1)
    },
    load(currentPage) {
      if (currentPage) {
        this.pager.current = currentPage
      }
      this.loading = true
      goodsMaterialsOptions({
        search: (this.querySearch || '').trim(),
        currentPage: this.pager.current,
        pageSize: this.pager.pageSize
      }).then((res) => {
        if (res.code === 200) {
          this.rows = res.data.rows || []
          this.pager.total = res.data.total || 0
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onTableChange(pagination) {
      this.pager.current = pagination.current
      this.load()
    },
    selectMaterial(record) {
      this.selectedId = record.materialId
      this.selectedName = record.materialName
    },
    getImgUrl(imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      }
      return ''
    },
    handleOk() {
      if (!this.selectedId) {
        this.$message.warning('请先选择要绑定的商品')
        return
      }
      this.confirmLoading = true
      goodsAdd({
        materialId: this.selectedId,
        description: this.description || '',
        sort: this.sort === null || this.sort === undefined ? 0 : this.sort
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$emit('ok')
          this.close()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.bind-thumb { width: 40px; height: 40px; object-fit: cover; border-radius: 4px; border: 1px solid #eee; }
</style>
